<div class="flex-1 overflow-visible w-full p-4">
  <div class="max-w-[1200px] mx-auto w-full font-sans">
    <h1 class="text-[2rem] font-bold text-gray-800 mb-8 pb-4 border-b-2 border-gray-100 italic">
      {{ greetingKey() | translate }}@if (userFirstName()) {<span> {{ userFirstName() }}</span>}
    </h1>

    <div class="flex flex-col gap-8">
      <!-- Missing Data Alert (Phone or Address) -->
       @if (!loading() && isMissingData()) {
       <div
         class="flex flex-col md:flex-row items-start md:items-center gap-4 md:gap-6 p-4 md:p-6 rounded-xl shadow-md animate-slide-down bg-gradient-to-br from-[#fff4e6] to-[#ffe5cc] border-2 border-[#ff9933] border-l-[6px] border-l-[#ff6600]">
        <div class="text-4xl shrink-0 animate-pulse-slow">⚠️</div>
        <div class="flex-1 flex flex-col gap-2">
          <h3 class="text-xl font-bold text-[#cc5500] m-0">{{ 'portal.dashboard.data.missing.title' | translate }}</h3>
          <p class="text-base text-[#8b4000] m-0 leading-relaxed">
            @if (isMissingPhoneNumber() && isMissingAddressData()) {
            {{ 'portal.dashboard.data.missing.message.both' | translate }}
            } @else if (isMissingPhoneNumber()) {
            {{ 'portal.dashboard.data.missing.message.phone' | translate }}
            } @else {
            {{ 'portal.dashboard.data.missing.message.address' | translate }}
            }
          </p>
        </div>
         <button type="button" (click)="openEditDialog()"
           class="flex items-center justify-center gap-2 px-6 py-3 bg-gradient-to-br from-[#ff6600] to-[#ff8833] text-white border-0 rounded-lg text-base font-semibold cursor-pointer transition-all shadow-[0_2px_4px_rgba(255,102,0,0.3)] w-full md:w-auto shrink-0 hover:from-[#ff5500] hover:to-[#ff7722] hover:shadow-[0_4px_8px_rgba(255,102,0,0.4)] hover:-translate-y-0.5 active:translate-y-0 active:shadow-[0_2px_4px_rgba(255,102,0,0.3)] focus:outline focus:outline-[3px] focus:outline-orange-500/30 focus:outline-offset-2">
           <span class="text-[1.1rem]">✏️</span>
           {{ 'portal.dashboard.data.missing.action' | translate }}
         </button>
      </div>
      }

      <!-- User Information Card -->
      @if (userInfo()) {
       <div class="bg-white rounded-xl shadow-md p-8">
         <h2 class="text-xl font-semibold text-gray-700 mb-6">{{ 'portal.dashboard.userinfo.title' | translate }}</h2>
 
         <div class="flex flex-col gap-3">
          <!-- Troubleshooting Data: ID above username -->
          <div class="flex gap-2 px-3 items-center text-[10px] text-gray-400 uppercase tracking-widest font-mono">
            <span>ID:</span>
            <span>{{ troubleshootingData().contact_id }}</span>
          </div>

          <!-- Username -->
           @if (userInfo().sub) {
           <div class="flex flex-col md:flex-row gap-1 md:gap-3 p-3 bg-gray-50 rounded-lg items-start md:items-center">
             <span class="font-semibold text-gray-400 md:text-gray-500 min-w-[120px] text-[0.7rem] md:text-[0.9rem] uppercase md:capitalize">{{ 'portal.dashboard.userinfo.username' | translate
               }}:</span>
             <span class="text-gray-800 break-all font-medium">{{ userInfo().sub }}</span>
           </div>
           }

          <!-- First Name -->
           <div class="flex flex-col md:flex-row gap-1 md:gap-3 p-3 bg-gray-50 rounded-lg items-start md:items-center">
             <span class="font-semibold text-gray-400 md:text-gray-500 min-w-[120px] text-[0.7rem] md:text-[0.9rem] uppercase md:capitalize">{{ 'portal.dashboard.troubleshooting.first_name' |
               translate }}:</span>
             <span class="text-gray-800 font-medium">{{ troubleshootingData().first_name }}</span>
           </div>

          <!-- Last Name -->
           <div class="flex flex-col md:flex-row gap-1 md:gap-3 p-3 bg-gray-50 rounded-lg items-start md:items-center">
             <span class="font-semibold text-gray-400 md:text-gray-500 min-w-[120px] text-[0.7rem] md:text-[0.9rem] uppercase md:capitalize">{{ 'portal.dashboard.troubleshooting.last_name' |
               translate }}:</span>
             <span class="text-gray-800 font-medium">{{ troubleshootingData().last_name }}</span>
           </div>

          <!-- Role Status -->
           <div class="flex flex-col md:flex-row gap-2 md:gap-3 p-3 bg-gray-50 rounded-lg items-start md:items-center">
             <span class="font-semibold text-gray-400 md:text-gray-500 min-w-[120px] text-[0.7rem] md:text-[0.9rem] uppercase md:capitalize">Status:</span>
             <div class="flex flex-wrap items-center gap-4 md:gap-6">
               @if (troubleshootingData().isStudent) {
               <div class="flex items-center gap-2">
                 <span class="text-xs text-gray-400">{{ 'portal.dashboard.troubleshooting.is_student' | translate
                   }}:</span>
                 <span class="material-symbols-outlined text-green-700 font-bold text-lg">check</span>
               </div>
               }
               @if (troubleshootingData().isLecturer) {
               <div class="flex items-center gap-2">
                 <span class="text-xs text-gray-400">{{ 'portal.dashboard.troubleshooting.is_lecturer' | translate
                   }}:</span>
                 <span class="material-symbols-outlined text-green-700 font-bold text-lg">check</span>
               </div>
               }
               @if (!troubleshootingData().isStudent && !troubleshootingData().isLecturer) {
               <span class="text-xs text-gray-300 italic">Keine Rollen zugewiesen</span>
               }
             </div>
           </div>
        </div>
      </div>
      }

    </div>
  </div>